import { styled } from "@mui/system";

const Div = styled("div")({});

export default Div;
